
import {DELETE_ERROR_ERROR} from "../../../reducers/errorsReducer";


export const deleteErrorError = (error) =>{
    return {
        type: DELETE_ERROR_ERROR,
        payload: {error}
    }
}